function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7 4h3v3H7zm0 6h3v3H7zm0 6h3v3H7zm6-6h3v3h-3zm0-6h3v3h-3zm0 12h3v3h-3z",
  fill: "#c7c7c7"
});

function SvgDots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24
  }, props), _ref);
}

export default SvgDots;